Preloader = require "lib/preload"
SlideView = require "views/slide"
{ Sound } = Application.actions()

class ImageCollectionView extends SlideView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  events: ->
    "click .btn-done":        "submit"
    "click .image-details":   "hideDetails"
    "click .tappy":           "toggleThumbnail"

  serialize: ->
    data = super
    data.tappies = _.filter(data.images or [], (d) -> d.image)
    data.hasPrompt = true
    data

  onResize: ->
    @el.classList.remove("active")

    images = _.pluck(@options.data.images, "image")

    Preloader.load _.compact(images), =>
      @setTappyHeight()
      @fitText =>
        window.setTimeout (=> @el.classList.add("active")), 300

  onDetailResize: -> 
    image = @getEl("active-details")
    @limitImageSize(image)

  show: ->
    @setEl @findOne(".tappies-parent"), "parent"
    @setEl @findOne(".tappies"), "tappies"
    @setEl @findOne(".title-wrapper"), "title"
    @setEl @findAll(".image-details"), "imageDetails"

    @listenTo this, "resize", @onResize
    @onResize()
    @toVisit = [0...@serialize().tappies.length]
    @hideDetails()

  beforeHide: ->
    @sendAudioTemplateAudio(null,false)

  setTappyHeight: ->
    length = @getEl("tappies").children.length
    length = Math.ceil(length / 2) if length >= 4

    outerHeight = @getEl("parent").offsetHeight - @getEl("title").offsetHeight
    tappyHeight = outerHeight / length
    tappyHeight = Math.min(tappyHeight, 220)

    for el, i in @getEl("tappies").children
      el.style.height = "#{tappyHeight}px"

  limitImageSize: (imgDetails) ->
    img = imgDetails.querySelector(".image-full-size")
    txt = imgDetails.querySelector(".caption")
    ch  = imgDetails.offsetHeight - txt.offsetHeight
    cw  = imgDetails.offsetWidth

    scale = _.max [ img.height / ch, img.width / cw ]

    img.style.height = "#{img.height / scale}px"

  toggleThumbnail: (e) ->
    @showDetails e.currentTarget, true

  showDetails: (tappy, animate) ->
    index      = +tappy.dataset.index
    imgDetails = @getEl("imageDetails").item(index)
    narration  = @serialize().tappies[index].narration
    loaded     = false
    img        = imgDetails.querySelector(".image-full-size")

    @setEl tappy, "prev-focused-btn" # Store which button the user clicked

    # ignore accessibility auto focus on the LMS or, this can mess up the authoring tool input focus
    if !window.ED_LMS_PREVIEW and !window.ED_PUBLIC_PREVIEW
      tappy.blur() # remove focus from button for screen reader
      img.setAttribute("tabindex", "0")
      img.focus()

    if (@currentSrc = narration) and not @withoutNarration
      @sendAudioTemplateAudio(@currentSrc,false)
    else
      @sendAudioTemplateAudio(null, false)

    @toVisit   = _.without @toVisit, index

    @setEl imgDetails, "active-details"

    @setState("touched") if _.isEmpty(@toVisit)
    @setState("active", "details")
    @showLightbox()

    @listenTo this, "resize", @onDetailResize
    @onDetailResize()

    @getEl("parent").setAttribute("aria-hidden", "true")

    for el in @getEl("tappies").children
      el.setAttribute("aria-hidden", "true")
      for child in el.children
        child.setAttribute("aria-hidden", "true")

    tappy.classList.add("visited")

    imgDetails.setAttribute("aria-hidden", "false");

    @transform imgDetails,
      opacity: 1
      transition: if animate then "all 300ms" else ""
   
    imgDetails.classList.add("image-details-visible")

  hideDetails: ->
    @sendAudioTemplateAudio(null, false)

    return unless imgDetails = @getEl("active-details")

    # Focus screen reader on previously clicked button
    @getEl("prev-focused-btn")?.focus()

    @transform imgDetails,
      opacity: 0
      scale: 0.9
      transition: "all 300ms"
    
    imgDetails.setAttribute("aria-hidden", "true");

    imgDetails.classList.remove("image-details-visible")

    @trigger("ui", lightbox: false)
    @setState("inactive", "details")

    @getEl("parent").setAttribute("aria-hidden", "false")

    for el in @getEl("tappies").children
      el.setAttribute("aria-hidden", "false")
      for child in el.children
        child.setAttribute("aria-hidden", "false")

  showLightbox: ->
    if @options.data.lightbox
      @trigger("ui", lightbox: @options.data.background or true)

  refresh: (params) ->
    if params.data.images.length is @options.data.images.length
      for { content }, i in params.data.images
        if content and @options.data.images[i]?.content isnt content
          changed = i

    super

    if changed? and tappy = @getEl("tappies").children[changed]
      @showDetails(tappy, false)


module.exports = ImageCollectionView
